import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IInitJuradBody, IInitJuradResponse } from '../models/jurad.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JuradValidationService {
  private url = environment.HttpUrl;

  private headers = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  juradService(data: IInitJuradBody) {
    return this.http.post(`${this.url}/IdVal`, data, this.headers);
  }
}
